/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchOrganizationComboRequest } from './PatchOrganizationComboRequest';
import {
    PatchOrganizationComboRequestFromJSON,
    PatchOrganizationComboRequestFromJSONTyped,
    PatchOrganizationComboRequestToJSON,
    PatchOrganizationComboRequestToJSONTyped,
} from './PatchOrganizationComboRequest';

/**
 * 
 * @export
 * @interface PatchOrganizationCombosBulkRequest
 */
export interface PatchOrganizationCombosBulkRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchOrganizationCombosBulkRequest
     */
    ids: Array<string>;
    /**
     * 
     * @type {PatchOrganizationComboRequest}
     * @memberof PatchOrganizationCombosBulkRequest
     */
    update: PatchOrganizationComboRequest;
}

/**
 * Check if a given object implements the PatchOrganizationCombosBulkRequest interface.
 */
export function instanceOfPatchOrganizationCombosBulkRequest(value: object): value is PatchOrganizationCombosBulkRequest {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    if (!('update' in value) || value['update'] === undefined) return false;
    return true;
}

export function PatchOrganizationCombosBulkRequestFromJSON(json: any): PatchOrganizationCombosBulkRequest {
    return PatchOrganizationCombosBulkRequestFromJSONTyped(json, false);
}

export function PatchOrganizationCombosBulkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchOrganizationCombosBulkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
        'update': PatchOrganizationComboRequestFromJSON(json['update']),
    };
}

export function PatchOrganizationCombosBulkRequestToJSON(json: any): PatchOrganizationCombosBulkRequest {
    return PatchOrganizationCombosBulkRequestToJSONTyped(json, false);
}

export function PatchOrganizationCombosBulkRequestToJSONTyped(value?: PatchOrganizationCombosBulkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
        'update': PatchOrganizationComboRequestToJSON(value['update']),
    };
}

